<template>
  <div class="portfolio-page">
    <h1>My Portfolio</h1>
          <!-- 主体内容 -->
          <main>
        <AICG />
        <PortfolioIllustration :skills="PortfolioIllustration" />
        <GraphicDesign :info="GraphicDesign" />
        <WebDesign :experience="WebDesign" />
        <UIDesign />
        <PortfolioInformation :projects="PortfolioInformation" />
        <VideoEditing :education="VideoEditing" />
        
        <PortfolioSection :portfolio="portfolio" />
      </main>
  </div>
  </template>
  
  <script>
    import $ from 'jquery';
  window.$ = window.jQuery = $;  
  
  import '@/assets/css/style.css';
  import '@/assets/js/javascript.js';
  import resumeData from '@/data/resumeData.js';
  
  import AICG from '@/components/portfolio/AICG.vue';
  import PortfolioIllustration from '@/components/portfolio/PortfolioIllustration.vue';
  import GraphicDesign from '@/components/portfolio/GraphicDesign.vue';
  import WebDesign from '@/components/portfolio/WebDesign.vue';
  import UIDesign from '@/components/portfolio/UIDesign.vue';
  import PortfolioInformation from '@/components/portfolio/PortfolioInformation.vue';
  import VideoEditing from '@/components/portfolio/VideoEditing.vue';
  import PortfolioSection from '@/components/common/PortfolioSection.vue';
  
  export default {
    name: 'PortfolioPage',
    components: {
      PortfolioSection,
      AICG,
      PortfolioIllustration,
      GraphicDesign,
      WebDesign,
      UIDesign,
      PortfolioInformation,
      VideoEditing
    },
    data() {
      return {
        ...resumeData, 
      };
    },
  };
  </script>
  
  <style scoped>
  </style>
  